// extracted by mini-css-extract-plugin
module.exports = {"sectionSecondary":"SectionAdvantage_sectionSecondary_1Ce4_"};